import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ImpersonateStore } from './impersonate.store';
import { AppConfigQuery } from '../../../../core/state/app-config/app-config.query';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {
    DecodedToken,
    ImpersonationToken,
    MeInfo,
    SessionStore
} from '../../../../core/state/session/session.store';
import { UserLink } from '../../state/users/user.model';
import { ToastService } from '../../../../shared/services/toast/toast.service';
import { throwError } from 'rxjs';
import { SessionQuery } from '../../../../core/state/session/session.query';
import jwtDecode from 'jwt-decode';

// TODO: merge with session state?
@Injectable({
    providedIn: 'root'
})
export class ImpersonateService {
    constructor(
        private impersonateStore: ImpersonateStore,
        private http: HttpClient,
        private config: AppConfigQuery,
        private location: Location,
        private toastService: ToastService,
        private sessionQuery: SessionQuery,
        private _sessionStore: SessionStore
    ) {}

    impersonateUser(userLink: UserLink) {
        if (!userLink.linkedUserUsername) {
            console.warn('No username found for user with id: ' + userLink.linkedUserId);
            return;
        }
        return this.http
            .get<ImpersonationToken>(
                `${this.config.get().adminBaseUrl}/keycloak/token-exchange`,
                {
                    headers: {
                        Authorization: `Bearer ${this.sessionQuery.access_token}`
                    },
                    params: {
                        subject: userLink.linkedUserUsername
                    }
                }
            )
            .pipe(
                tap((token) => {
                    const decodedToken = jwtDecode<DecodedToken>(token.access_token);
                    this.impersonateStore.update({
                        userId: userLink.linkedUserId,
                        token,
                        decodedToken
                    });
                    this._resetApplication();
                }),
                catchError((err) => {
                    // something went wrong
                    this.toastService.show({
                        intent: 'critical',
                        message: `Failed to switch user (code: ${err.error.status}), please try again later.`
                    });
                    return throwError(err);
                })
            );
    }

    endImpersonation() {
        // TODO: we should revoke token as well, i.e. log out the impersonated user
        this.impersonateStore.reset();
        this._resetApplication('/impersonation/users');
    }

    private _resetApplication(url: string = '/') {
        this._sessionStore.sessionChannel.postMessage({
            payload: {
                userId: this.sessionQuery.user.userId,
                type: 'TOKEN_EXCHANGE'
            }
        });
        // create new url to start page with environment e.g. https://test.swimbird.io/swim-1234/
        let startUrl = `${window.location.origin}${this.location.prepareExternalUrl(
            url
        )}`;

        // if feeder environment, remove trailing slash
        if (window['sbEnv'] && startUrl.endsWith('/')) {
            startUrl = startUrl.replace(/\/$/, '');
        }
        window.location.href = startUrl;
    }
}
